//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import constants from '~/constants';
import ContentCross from '~/components/tutorial/ContentCross';
import ContentHtml from '~/components/tutorial/ContentHtml';

export default {
  name: 'Tutorial',

  components: {
    ContentCross,
    ContentHtml,
  },

  data() {
    return {
      CDN: process.env.CDN,
      constants,
      activeTab: 0,

      // settings for swiper
      swiperOption: {
        spaceBetween: 0,
        speed: 400,
        loop: this.isLoop,
        loopedSlides: 5,
        resizeObserver: true,
        slidesPerView: 3,
        slideToClickedSlide: false,
        breakpoints: {
          751: {
            slidesPerView: 5,
          },
        },
        on: {
          click: (swiper, event) => {
            event.preventDefault();

            this.activeTab = swiper.clickedIndex % this.tutorials.length;
          },
        },
      },
    };
  },

  computed: {
    ...mapState(['tutorials', 'isMobile']),
    isLoop: {
      get() {
        return (
          (this.isMobile && this.tutorials.length > 3) ||
          (!this.isMobile && this.tutorials.length > 5)
        );
      },
      set(val) {
        return val;
      },
    },
    activeTutorial() {
      return this.tutorials.find((_, index) => index === this.activeTab);
    },
    queryTab() {
      return Number(this.$route.query.active);
    },
  },

  watch: {
    isMobile: {
      handler(val) {
        this.isLoop =
          (val && this.tutorials.length > 3) ||
          (!val && this.tutorials.length > 5);
      },
      immediate: true,
    },
    queryTab: {
      handler(val) {
        if (val >= 0) {
          this.activeTab = val;
          this.$router.replace({ query: null });
        }
      },
      immediate: true,
    },
  },

  async validate({ store, query }) {
    const queryVerification = query.active ? Number(query.active) : true;
    let tutorials = null;

    if (queryVerification || queryVerification >= 0) {
      tutorials = await store.dispatch('getTutorials');
    }

    return (queryVerification || queryVerification >= 0) && !!tutorials;
  },
};
